import { createSlice } from '@reduxjs/toolkit';
import { getEgiftTemplates } from '~store/product-detail/thunks';

const initialState = {
  step: 1,
  selectedImage: '',
  selectedCombinationId: '',
  selectedCombinationPrice: null,
  selectedCombinationPriceKey: -1,
  formFilled: false,
  payload: {
    recipient_phone_no: '',
    recipient_email: '',
    message: '',
    delivery_date: '',
    recipient_name: '',
    sender_name: '',
    is_confirm: true,
  },
  buttonChooseTemplateTheme: 'primary',
  buttonUploadPhotoTheme: 'light-primary',
  designType: 'template',
  photoUploaded: null,
  messageTemplates: [],
  photoUploadedAfterAddWatermark: null,
  finalPhoto: null,
  tempMessageTemplates: [],
  status: {
    messageTemplates: 'idle',
  },
};

export const { reducer } = createSlice({
  name: 'productDetailEgift',
  initialState,
  reducers: {
    resetEgift() {
      return { ...initialState };
    },
    resetEgiftPayload(state) {
      state.payload = {
        recipient_phone_no: '',
        recipient_email: '',
        message: '',
        delivery_date: '',
        recipient_name: '',
        sender_name: '',
        is_confirm: true,
      };
    },
    setEgift(state, action) {
      return { ...state, ...action.value };
    },
    setButtonChooseTemplateTheme(state, action) {
      state.buttonChooseTemplateTheme = action.value;
    },
    setButtonUploadPhotoTheme(state, action) {
      state.buttonUploadPhotoTheme = action.value;
    },
    setEgiftDesignType(state, action) {
      state.designType = action.value;
    },
    setPhotoUploaded(state, action) {
      state.photoUploaded = action.value;
    },
    incrementStepOnEgiftForm(state) {
      state.step += 1;
    },
    decrementStepOnEgiftForm(state) {
      state.step -= 1;
    },
    setEgiftPayloadMessage(state, action) {
      state.payload.message = action.message;
    },
    setPhotoUploadedAfterAddWatermark(state, action) {
      state.photoUploadedAfterAddWatermark = action.value;
    },
    setFinalPhoto(state, action) {
      state.finalPhoto = action.value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEgiftTemplates.rejected, (state) => {
        state.status.messageTemplates = 'failed';
      })
      .addCase(getEgiftTemplates.pending, (state) => {
        state.status.messageTemplates = 'loading';
      })
      .addCase(getEgiftTemplates.fulfilled, (state, { payload }) => {
        state.messageTemplates = payload.data;
        state.status.messageTemplates = 'succeeded';
      });
  },
});

export default reducer;
